module.exports = __webpack_public_path__ + "static/img/tow.591c1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appleImg/tow.png
// module id = f/Mq
// module chunks = 1